<template>
  <div class="toggle-button" :class="[{checked, locked}, style.toggle]" @click.prevent="toggle">
    <div class="toggle-button-inner">
      <span class="handle" />
    </div>
    <p v-if="hasText" class="text">{{text}}</p>
  </div>
</template>

<script>
  export default {
    
    props: ['text', 'filters', 'dispatchKey', 'propertyName', 'isChecked', 'hasText', 'locked'],
    data () {
      return {
        checked: this.isChecked || false,
        value: null
      }
    },
    computed: {
      style () {
        return {
          toggle: this.$css(`
            &.toggle-button {
              .toggle-button-inner {
                .handle {
                  background: ${this.theme.toggleButtonColor} !important;
                }
              }
              &.checked {

                .toggle-button-inner {
                  background: ${this.theme.toggleBackgroundColor} !important;
                }
              }
            }
          `)
        }
      }
    },
    methods: {
      toggle () {
        if (this.locked) {
          return
        }
        this.checked = !this.checked
        switch (this.checked) {
          case false:
            this.value = this.filters[0]
            break

          case true:
            this.value = this.filters[1]
            break
        }

        let answerData = {}
        answerData[this.propertyName] = {
          consent: this.checked
        }
        this.$store.dispatch(this.dispatchKey, answerData)
        this.$emit('toggle', this.value)
      }
    },

    mounted () {
      this.value = this.filters[0]
      this.$emit('toggle', this.value)
    },

    watch: {
      isChecked (val) {
        this.checked = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  .toggle-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    &.locked {
      cursor: initial;
      .toggle-button-inner {
        &:after {
          content: "";
          position: absolute;
          top: 7px;
          left: 5px;
          width: 10px;
          height: 10px;
          background-image: url('~static/lock.png');
          background-size: 10px 10px;
        }
      }
    }

    .toggle-button-inner {
      display: flex;
      width: 40px;
      height: 25px;
      background: #DEDEDE;
      border-radius: 18px;
      position: relative;
      transition: background .2s ease-in;

      .checkbox {
        -webkit-appearance: checkbox;
        display: none;
      }

      .handle {
        height: 16px;
        width: 16px;
        background: $toggleButtonColor;
        border-radius: 50px;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.01);
        position: absolute;
        left: 5px;
        top: 5px;
        transition: left .2s ease-in;
      }
    }

    .text {
      font-family: Arial;
      font-size: 14px;
      line-height: 22px;
      margin-left: 12px;
    }

    &.checked {

      .toggle-button-inner {
        background: $toggleBackgroundColor;
        .handle {
          left: calc(100% - 21px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ToggleButton.vue